import { render, staticRenderFns } from "./tax-rates.vue?vue&type=template&id=e549f3d4"
import script from "./tax-rates.vue?vue&type=script&lang=js"
export * from "./tax-rates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports